import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import AccountSidebar from "@/components/account/AccountSidebar";
import { Trash2, Plus, Edit2 } from "lucide-react";

const empty = { full_name:"", mobile:"", pincode:"", house:"", area:"", city:"", state:"", landmark:"", address_type:"Home", is_default:false };

export default function Addresses() {
  const [list, setList] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);

  const load = () => api.get("/addresses").then(r => setList(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    if (editing) await api.put(`/addresses/${editing}`, form);
    else await api.post("/addresses", form);
    await load();
    setForm(empty); setEditing(null);
    toast.success("Saved");
  };

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 grid lg:grid-cols-[240px_1fr] gap-6">
      <AccountSidebar/>
      <section className="space-y-4">
        <h1 className="font-display text-2xl font-bold">Saved Addresses</h1>
        {list.map(a => (
          <div key={a.address_id} className="bg-white border border-slate-100 rounded-2xl p-4 flex items-start justify-between gap-3">
            <div>
              <div className="font-semibold text-sm">{a.full_name} · {a.mobile} {a.is_default && <span className="ml-2 text-xs text-[#004BCA]">Default</span>}</div>
              <div className="text-sm text-slate-600 mt-1">{a.house}, {a.area}, {a.city}, {a.state} - {a.pincode}</div>
            </div>
            <div className="flex gap-2">
              <button data-testid={`edit-addr-${a.address_id}`} onClick={()=>{setEditing(a.address_id);setForm(a);}} className="p-2 rounded-full hover:bg-slate-100"><Edit2 size={14}/></button>
              <button data-testid={`del-addr-${a.address_id}`} onClick={async()=>{ await api.delete(`/addresses/${a.address_id}`); load(); }} className="p-2 rounded-full hover:bg-slate-100 text-red-600"><Trash2 size={14}/></button>
            </div>
          </div>
        ))}
        <form onSubmit={save} className="bg-white border border-slate-100 rounded-2xl p-5">
          <div className="flex items-center gap-2 mb-4"><Plus size={16}/><h3 className="font-display font-bold">{editing?"Edit Address":"Add New Address"}</h3></div>
          <div className="grid sm:grid-cols-2 gap-3">
            {["full_name","mobile","pincode","house","area","city","state","landmark"].map(k => (
              <input key={k} value={form[k]||""} onChange={e=>setForm({...form,[k]:e.target.value})} placeholder={k.replace("_"," ")} required={k!=="landmark"} className="bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm" data-testid={`addr-${k}`}/>
            ))}
            <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={form.is_default} onChange={e=>setForm({...form,is_default:e.target.checked})} data-testid="addr-default"/> Set as default</label>
          </div>
          <div className="flex gap-2 mt-4">
            <button data-testid="addr-save" className="btn-primary-sf px-6 py-2.5 rounded-full text-sm font-semibold">{editing?"Update":"Save Address"}</button>
            {editing && <button type="button" onClick={()=>{setEditing(null);setForm(empty);}} className="px-6 py-2.5 rounded-full text-sm font-semibold border border-slate-200">Cancel</button>}
          </div>
        </form>
      </section>
    </main>
  );
}
